module.exports = __webpack_public_path__ + "static/img/1865cc8c4025587382cdc9d93df2f34c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_01.png
// module id = 6Jfb
// module chunks = 1